import { BaseOption, BasicFilterSelect, BasicSelectProps, SelectValueType } from 'ui/selects';

import { BaseContainer, Body2Label } from '../../modals/CopyTemplateModal/CopyTemplateModal.styled';

type LabelledSelectProps<TValue extends SelectValueType = number> = Partial<
  Omit<BasicSelectProps<TValue>, 'onSelect'>
> & {
  /** Function to select */
  onSelect: (selection: TValue) => void;
  options: BaseOption<TValue>[];
  /** Label String */
  title: string;
  /** Select Placeholder */
  placeholder: string;
  /** If Select is empty */
  empty: string;
};

export function LabelledSelect<TValue extends SelectValueType = number>({
  onSelect,
  options,
  title,
  placeholder,
  empty,
  ...props
}: LabelledSelectProps<TValue>) {
  return (
    <>
      <Body2Label>{title}</Body2Label>
      <BaseContainer>
        <BasicFilterSelect
          defaultValues={[]}
          placeholder={options.length > 0 ? placeholder : empty}
          id="labelled-select"
          options={options}
          onSelect={([selected]) => onSelect(selected)}
          // automaticallyAvoidCollisions={true}
          {...props}
        />
      </BaseContainer>
    </>
  );
}
